// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xvofUX {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.WCx8f5 {
  font-size: var(--type-label-lg-font-size);
  font-weight: var(--type-label-lg-font-weight);
  color: var(--text-neutral-dark);
  margin: 0;
}

.L6v6MC {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
}

.G6GXQR {
  background-color: transparent !important;
  gap: 8px;
  padding: 0;
  width: auto;
  max-width: auto;
}

.cEcyV8 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.i_1oFR {
  font-size: var(--font-size-sm);
  color: var(--text-helper);
}

.TOt0WQ {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-3);
}

.zB3Fke {
  flex: 1;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2);
  background-color: var(--surface-neutral-pale);
  border-radius: var(--radius-s);
  cursor: pointer;
  transition: all 0.2s ease;
  gap: var(--spacing-1-5);
}

.zB3Fke[data-selected='true'] {
  background-color: var(--surface-primary-subtle);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/ParametersPage/components/ParametersStep1/ParametersStep1.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,QAAQ;EACR,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6CAA6C;EAC7C,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".formSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.sectionTitle {\n  font-size: var(--type-label-lg-font-size);\n  font-weight: var(--type-label-lg-font-weight);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.radioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n}\n\n.radioItemParams {\n  background-color: transparent !important;\n  gap: 8px;\n  padding: 0;\n  width: auto;\n  max-width: auto;\n}\n\n.specificDayContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.helpText {\n  font-size: var(--font-size-sm);\n  color: var(--text-helper);\n}\n\n.horizontalRadioGroup {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-3);\n}\n\n.horizontalRadioItem {\n  flex: 1;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-2);\n  background-color: var(--surface-neutral-pale);\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  gap: var(--spacing-1-5);\n}\n\n.horizontalRadioItem[data-selected='true'] {\n  background-color: var(--surface-primary-subtle);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formSection": `xvofUX`,
	"sectionTitle": `WCx8f5`,
	"radioGroup": `L6v6MC`,
	"radioItemParams": `G6GXQR`,
	"specificDayContainer": `cEcyV8`,
	"helpText": `i_1oFR`,
	"horizontalRadioGroup": `TOt0WQ`,
	"horizontalRadioItem": `zB3Fke`
};
module.exports = ___CSS_LOADER_EXPORT___;
